// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ezMenu-main {
  padding: 4px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  /* Var --ezClockerSilver defined in ez-body.css */
  background-color: var(--ezClockerSilver);
  /* Var --ezClockerBlack defined in ez-body.css */
  color: var(--ezClockerBlack);
  font-weight: bold;
  border-style: solid;
  /* Var --ezClockerGray defined in ez-body.css */
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-top-width: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-menu.css"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iDAAA;EACA,wCAAA;EACA,gDAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;EACA,+CAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,+BAAA;EACA,8BAAA;AACJ","sourcesContent":[".ezMenu-main {\r\n    padding: 4px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n    margin-bottom: 10px;\r\n    /* Var --ezClockerSilver defined in ez-body.css */\r\n    background-color: var(--ezClockerSilver);\r\n    /* Var --ezClockerBlack defined in ez-body.css */\r\n    color: var(--ezClockerBlack);\r\n    font-weight: bold;\r\n    border-style: solid;\r\n    /* Var --ezClockerGray defined in ez-body.css */\r\n    border-color: var(--ezClockerGray);\r\n    border-width: 1px;\r\n    border-top-width: 0;\r\n    border-bottom-right-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
